module.exports = __webpack_public_path__ + "23fcf29df41c514b76f18237a46f0eaf.svg";